import {Component, input, model, ViewEncapsulation} from '@angular/core';
import {MatButtonToggle, MatButtonToggleGroup} from '@angular/material/button-toggle';

export interface TabOption<T = string> {
    value: T;
    label: string;
    count?: number | null;
}

/**
 * Segmented control (grey container, active tab white). Built on mat-button-toggle-group:
 * the pages switch their content with `@switch` on `[(value)]`.
 */
@Component({
    selector: 'app-tab-group',
    imports: [MatButtonToggleGroup, MatButtonToggle],
    templateUrl: './tab-group.component.html',
    styleUrl: './tab-group.component.scss',
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class.ui-tab-group-sm]': 'size() === "sm"',
        '[class.ui-tab-group-dark]': 'theme() === "dark"'
    }
})
export class TabGroupComponent<T = string> {
    readonly options = input<TabOption<T>[]>([]);
    readonly value = model<T | null>(null);
    readonly size = input<'sm' | 'md'>('md');
    readonly theme = input<'light' | 'dark'>('light');
    readonly label = input<string>();
}
